/**
 * Original brand illustrations per case category — dignified, abstract, on-brand
 * (deep green + gold + cream). Used on Served-wall cards when no field photo is shown
 * (or under campaign-safe mode). No third-party stock → no consent/licensing risk.
 */
import { HandHeart } from 'lucide-react';

const wrap = (children, label) => (
  <svg viewBox="0 0 320 200" role="img" aria-label={label} preserveAspectRatio="xMidYMid slice" style={{ width: '100%', height: '100%' }}>
    <defs>
      <linearGradient id="catSky" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#1E4D3A" />
        <stop offset="1" stopColor="#14342A" />
      </linearGradient>
    </defs>
    <rect width="320" height="200" fill="url(#catSky)" />
    {children}
  </svg>
);

export function CategoryArt({ category }) {
  switch (category) {
    case 'housing':
      return wrap(
        <g>
          <circle cx="252" cy="48" r="22" fill="#BF9447" opacity="0.85" />
          <path d="M70 150 L70 96 L130 60 L190 96 L190 150 Z" fill="#E8D8B0" />
          <path d="M62 100 L130 56 L198 100 L190 92 L130 50 L70 92 Z" fill="#BF9447" />
          <rect x="112" y="116" width="36" height="34" fill="#1B4332" />
          <rect x="84" y="108" width="20" height="18" fill="#2D6A4F" />
          <rect x="156" y="108" width="20" height="18" fill="#2D6A4F" />
          <rect x="40" y="150" width="240" height="6" fill="#2D6A4F" opacity="0.5" />
        </g>,
        'Housing support',
      );
    case 'ration':
      return wrap(
        <g>
          <circle cx="60" cy="44" r="18" fill="#BF9447" opacity="0.8" />
          <path d="M120 80 h80 l-10 78 h-60 Z" fill="#E8D8B0" />
          <path d="M120 80 h80 l4 -14 h-88 Z" fill="#BF9447" />
          <path d="M150 66 q10 -22 20 0" fill="none" stroke="#1B4332" strokeWidth="4" />
          <rect x="132" y="100" width="56" height="6" fill="#2D6A4F" opacity="0.6" />
          <rect x="132" y="116" width="56" height="6" fill="#2D6A4F" opacity="0.45" />
          <rect x="40" y="158" width="240" height="6" fill="#2D6A4F" opacity="0.5" />
        </g>,
        'Ration support',
      );
    case 'medical':
      return wrap(
        <g>
          <circle cx="250" cy="150" r="42" fill="#2D6A4F" opacity="0.45" />
          <rect x="120" y="60" width="80" height="80" rx="10" fill="#E8D8B0" />
          <rect x="152" y="74" width="16" height="52" rx="4" fill="#9B3D2E" />
          <rect x="134" y="92" width="52" height="16" rx="4" fill="#9B3D2E" />
          <rect x="40" y="150" width="240" height="6" fill="#2D6A4F" opacity="0.5" />
        </g>,
        'Medical support',
      );
    default:
      // Care / welfare — a clean, centered line icon on the brand green. No circles.
      return (
        <div
          role="img"
          aria-label="Welfare support"
          style={{
            width: '100%',
            height: '100%',
            background: 'linear-gradient(180deg, #1E4D3A, #14342A)',
            display: 'grid',
            placeItems: 'center',
          }}
        >
          <HandHeart
            aria-hidden="true"
            strokeWidth={1.3}
            color="#E8D8B0"
            style={{ width: '38%', height: 'auto' }}
          />
        </div>
      );
  }
}

export default CategoryArt;
